<template>
  <div class="project-type-warranties-page">
    <CustomTable
      title="Процент гарантии"
      :rowsData="rowsData"
      :columns="projectTypeWarrantiesColumns"
      :loading="isFetching"
      :show-search="true"
      :custom-body="true"
      :sticky-header="true"
      :dense="true"
    >
      <template #customBody="props">
        <q-tr>
          <custom-table-cell align="center">
            {{ props.row.project_type_id }}
          </custom-table-cell>

          <custom-table-cell align="left">
            {{ props.row.project_type_name }}
          </custom-table-cell>

          <custom-table-cell align="center">
            {{ props.row.warranty_contractor }}%
          </custom-table-cell>

          <custom-table-cell align="center">
            {{ props.row.warranty_team_project }}%
          </custom-table-cell>

          <custom-table-cell align="center" vertical-align="center">
            <CustomIcon @click="() => this.handleUpdateClick(props.row)" icon="edit" />
          </custom-table-cell>
        </q-tr>
      </template>
    </CustomTable>
  </div>
</template>

<script>
import CustomTable from "@/components/common/CustomTable";
import CustomTableCell from "@/components/common/CustomTable/custom-table-cell";
import CustomIcon from "@/components/common/CustomIcon";
import { useCustomSnackbar } from "@/_helpers/hooks/useCustomSnackbar";
import { MODAL_NAMES } from "@/constants";
import { useAppStore } from "@/services/store/app";
import {
  getProjectTypeWarranties,
  projectTypeWarrantiesColumns,
  updateProjectTypeWarranty,
} from "@/views/ProjectTypeWarranties/services";

export default {
  name: "ProjectTypeWarranties",
  components: { CustomTable, CustomTableCell, CustomIcon },
  data() {
    return {
      projectTypeWarrantiesColumns,
      rowsData: [],
      isFetching: false,
    };
  },
  methods: {
    async getData() {
      this.isFetching = true;
      const res = await getProjectTypeWarranties();
      this.isFetching = false;
      if (res) {
        this.rowsData = res;
      }
    },
    async handleUpdateClick(row) {
      this.showModal(MODAL_NAMES.Edit_Project_Type_Warranty, {
        onSubmit: (body) => this.onUpdateSubmit(row.project_type_id, body),
        title: "Изменить процент гарантии",
        body: row,
      });
    },
    async onUpdateSubmit(project_type_id, body) {
      const res = await updateProjectTypeWarranty(project_type_id, body);
      if (!res) return;
      this.rowsData = res;
      this.showSucceedSnackbar();
      this.closeModal();
    },
  },
  mounted() {
    this.getData();
  },
  setup() {
    const { showSucceedSnackbar } = useCustomSnackbar();
    const { showModal, closeModal } = useAppStore();
    return { showSucceedSnackbar, showModal, closeModal };
  },
};
</script>

<style scoped>
.project-type-warranties-page {
  padding: 0;
}
</style>
